// extracted by mini-css-extract-plugin
export default {"button":"Button_button__IY-Am","textBox":"Button_textBox__NLdlA","text":"Button_text__lBozd"};